import React, { useEffect, useRef } from "react";
import { useScreenDimensions, useDevice } from "../_layout";

import { useState } from "react";
import { Text, View, TouchableOpacity } from "react-native";
import GlobalStyles from "../../Resources/Styles";
import Colors from "../../Resources/Color";
import Fonts from "../../Resources/Fonts";
import { useTranslation } from "react-i18next";
import { Feather, Ionicons, Ionicons as IoniconsLib } from "@expo/vector-icons";

import { observer, Observer } from "mobx-react";

import VideoComponent from "../Components/VideoComponent";
import ImageComponent from "../Components/ImageComponent";
import ChatManager from "../Classes/ChatManager";
import MediaManager from "../Classes/MediaManager";
import { Chat } from "../../Resources/Constants";
import IconEmptyView from "../Components/IconEmptyView";
import LoadingLogo from "../Components/LoadingLogo";
import { getSlotColorWithOpacity } from "../utils/colorUtils";

const ChatMediaPlayer = observer(({ coach, fullScreen = false }) => {
  const { t, i18n } = useTranslation();
  const { isMobile } = useDevice();
  const { screenSize } = useScreenDimensions();

  const chatManager = ChatManager.getInstance();
  const mediaManager = MediaManager.getInstance();

  const message = mediaManager.messageToView;
  const serie = mediaManager.serieToView;
  const showingVideo = serie || message?.type === "video";

  const [url, setUrl] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [downloadError, setDownloadError] = useState(false);

  useEffect(() => {
    let isMounted = true;
    setUrl(false);
    setIsLoading(true);
    setDownloadError(false);
    const runEffect = async () => {
      if (isMounted) setIsLoading(true);
      try {
        const newUrl = await (message || serie).getAttachmentURL();
        if (newUrl && isMounted) {
          setUrl(newUrl);
        }
      } catch (error) {
        if (isMounted) setDownloadError(true);
        console.error("Error checking if video is downloaded:", error);
      }
      if (isMounted) setIsLoading(false);
    };

    runEffect();
    return () => {
      isMounted = false;
    };
  }, [serie, message]);

  if (downloadError && showingVideo) {
    return (
      <View
        style={{
          width: "100%",
          height: "100%",
          borderRadius: 16,
          borderWidth: 0.1,
          borderColor: Colors.borderColor,
          backgroundColor: Colors.lightGrayColor,
          marginBottom: 8,
        }}
      >
        <IconEmptyView
          iconLibrary={"Ionicons"}
          iconName={"warning-outline"}
          mainText={"videoNotAvailableTitle-string"}
          subText={"videoNotAvailableText-string"}
          marginTop={48}
          marginBottom={24}
        />
      </View>
    );
  }

  return (
    <View
      style={{
        position: "relative",
        // width: "100%",
        borderRadius: 16,
        borderWidth: 0.1,
        borderColor: Colors.borderColor,
        backgroundColor: Colors.lightGrayColor,
        overflow: "hidden",
        marginBottom: 8,
        justifyContent: "flex-end",
        flexShrink: 1,
        // maxHeight: 200,
      }}
    >
      {isLoading ? (
        <LoadingLogo
          container={false}
          width={75}
          height={75}
          flex={true}
          dark={true}
          marginBottom={48}
          marginTop={48}
        />
      ) : showingVideo && url ? (
        <>
          <VideoComponent
            url={url}
            width={
              fullScreen
                ? "auto"
                : screenSize != "small"
                ? coach.showingChatList
                  ? Chat.CHAT_WIDTH - 160
                  : Chat.CHAT_WIDTH
                : coach.showingChatList
                ? Chat.CHAT_WIDTH - 160
                : Chat.CHAT_WIDTH - 90
            }
            nativeControls={false}
            contentFit="cover"
            allowsFullscreen={false}
            allowsPictureInPicture={false}
            loop={true}
            muted={true}
            autoPlay={true}
            // Overlay props
            weekText={
              (message?.getSerie || serie) &&
              (message?.getSerie || serie).exercise?.workout?.week > 0 &&
              (message?.getSerie || serie).exercise?.workout?.block
                ?.totalWeeks > 0
                ? t("clientWeekStatus-string", {
                    blockCurrentWeek: (message?.getSerie || serie).exercise
                      .workout.week,
                    blockWeeks: (message?.getSerie || serie).exercise.workout
                      .block.totalWeeks,
                  })
                : null
            }
            serieDetails={
              message?.getSerie || serie ? (
                <>
                  {(() => {
                    const parts = (
                      message?.getSerie || serie
                    ).getFormattedTextParts(
                      coach.rirOrRpe,
                      coach.exerciseUnit,
                      false
                    );
                    return (
                      <>
                        <Text
                          style={{
                            fontSize: 11,
                            color: Colors.whiteColor,
                          }}
                        >
                          {parts.weightText}
                        </Text>
                        <Text
                          style={{
                            fontSize: 11,
                            color: Colors.whiteColor,
                          }}
                        >
                          {parts.repsText}
                        </Text>
                        <Text
                          style={{
                            fontSize: 11,
                            color: parts.rpeColor,
                          }}
                        >
                          {parts.rpeLabel}
                        </Text>
                        <Text
                          style={{
                            fontSize: 11,
                            color: parts.rpeColor,
                          }}
                        >
                          {parts.rpeValue}
                        </Text>
                      </>
                    );
                  })()}
                </>
              ) : null
            }
            exerciseName={
              message?.getSerie || serie
                ? (message?.getSerie || serie).exercise.getName(
                    t,
                    i18n.language
                  )
                : null
            }
            protocolSlot={
              (message?.getSerie || serie)?.exercise?.protocolSlot
                ? t((message?.getSerie || serie).exercise.protocolSlot)
                : null
            }
            protocolSlotColor={
              (message?.getSerie || serie)?.exercise?.protocolSlot
                ? getSlotColorWithOpacity(
                    (message?.getSerie || serie).exercise.protocolSlot
                  )
                : null
            }
          />
        </>
      ) : message?.type === "image" && url ? (
        <ImageComponent
          imageURL={url}
          width={
            fullScreen
              ? "auto"
              : screenSize != "small"
              ? coach.showingChatList
                ? Chat.CHAT_WIDTH - 120
                : Chat.CHAT_WIDTH
              : coach.showingChatList
              ? Chat.CHAT_WIDTH - 120
              : Chat.CHAT_WIDTH - 90
          }
          maxHeight={"100%"}
          borderRadius={12}
          large={true}
        />
      ) : (
        <IconEmptyView
          iconLibrary={"Ionicons"}
          iconName={"warning-outline"}
          mainText={"NoFileFoundTitle-string"}
          subText={"NoFileFoundText-string"}
          marginTop={48}
          marginBottom={24}
        />
      )}
      <TouchableOpacity
        onPress={() => {
          mediaManager.closeMediaPlayer();
        }}
        style={{
          position: "absolute",
          top: 12,
          right: 12,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          borderRadius: 13,
          width: 26,
          height: 26,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Feather name="x" size={20} color={Colors.whiteColor} />
      </TouchableOpacity>
    </View>
  );
});

export default ChatMediaPlayer;
